import { SyntheticEvent, useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  CheckboxProps,
  Header,
  Modal,
} from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import agent from '../../../../app/api/agent';
import ResolveOptions from './resolveOptions';
import { toast } from 'react-toastify';
import TatTimeField from './TatTimeField';
import { useStore } from '../../../../app/stores/store';
import LoadingComponent from '../../../../app/layout/LoadingComponent';

interface IAutoRejectSetting {
  subtaskId: string;
  modalCloseHandler: () => void;
}

function AutoRejectSetting(props: IAutoRejectSetting) {
  const { modalCloseHandler, subtaskId } = props;
  const { TemplateStore } = useStore();

  // const [parallelSubtask, setParallelSubtask] = useState<{
  //   tasks: any[];
  //   selectedParallelSubTask: {
  //     subTaskId: string;
  //     subTaskName: string;
  //   };
  // }>({
  //   tasks: [],
  //   selectedParallelSubTask: { subTaskId: '', subTaskName: '' },
  // });
  const [errorAndLoader, setErrorAndLoader] = useState({
    error: '',
    isLoading: true,
    saveLoading: false,
  });
  const [resolveOptions, setResolveOptions] = useState<{
    tasks: any[];
    selectedSubtask: { subTaskId: string; subTaskName: string };
  }>({
    tasks: [],
    selectedSubtask: { subTaskId: '', subTaskName: '' },
  });
  const [tat, updateTat] = useState<string>('');
  const [newTat, updateNewTat] = useState<string>('');
  const [isFinish, setIsFinish] = useState<boolean>(false);
  const [isParallelST, setIsParallelST] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        setErrorAndLoader({
          error: '',
          isLoading: true,
          saveLoading: false,
        });
        let [subtaskDetails, rejectDetails] = await Promise.all([
          agent.workflowSubtasks.subtaskAloneAPI({
            id: subtaskId,
          }),
          agent.workflowSubtasks.resolveOptionsAPI({
            subtaskId,
          }),
          // agent.workflowSubtasks.getAllTaskAndSubtaskDetails({
          //   templateId: TemplateStore?.selectedTemplate?.templateId || '',
          //   subtaskId,
          // }),
        ]);

        if (subtaskDetails?.data) {
          setIsFinish(!!subtaskDetails.data?.isFinish);
          setIsParallelST(!!subtaskDetails.data?.isParallelsubtask)
        }
        if (rejectDetails?.data) {
          setResolveOptions(rejectDetails.data);
        }
        // if (parallelDetails?.data) {
        //   setParallelSubtask(parallelDetails.data);
        // }
        setErrorAndLoader({
          error: '',
          isLoading: false,
          saveLoading: false,
        });
      } catch {
        setErrorAndLoader({
          error: 'Something went wrong',
          isLoading: false,
          saveLoading: false,
        });
      }
    })();
    //eslint-disable-next-line
  }, []);

  const getchangedTat = (tatTime: string, changedTat: string) => {
    updateTat(tatTime);
    updateNewTat(changedTat);
  };
  const handleFormSubmit = async () => {
    setErrorAndLoader({
      ...errorAndLoader,
      isLoading: false,
      saveLoading: true,
    });
    try {
      await agent.NFAI.IsparallelsubTaskUpdate(subtaskId, isParallelST);
      // ----------------- schedule & Reschedule ------------------- //
      if (newTat !== tat) {
        TemplateStore.updateSubTaskTat(subtaskId, newTat);
        setTimeout(() => {
          TemplateStore.loadTaskById(TemplateStore.selectedTasks?.taskId || '');
        }, 500);
      }

      let rejectParams = {
        id: subtaskId,
        rejectToId: resolveOptions.selectedSubtask?.subTaskId || '',
      };
      let params = {
        subTaskId: subtaskId,
        isFinish,
      };
      // let [autoReject, finish, parallelUpdate] = await Promise.all([
      //   agent.workflowSubtasks.autoRejectUpdate(rejectParams),
      //   agent.workflowSubtasks.updateFinishAPI(params),
      //   agent.workflowSubtasks.updateParallelSubtask({
      //     subTaskId: subtaskId,
      //     parallelSubtaskId: parallelSubtask?.selectedParallelSubTask?.subTaskId || "",
      //   }),
      // ]);
      let autoReject =
        await agent.workflowSubtasks.autoRejectUpdate(rejectParams);
      let finish = await agent.workflowSubtasks.updateFinishAPI(params);
      // let parallelUpdate = await agent.workflowSubtasks.updateParallelSubtask({
      //   subTaskId: subtaskId,
      //   parallelSubtaskId:
      //     parallelSubtask?.selectedParallelSubTask?.subTaskId || '',
      // });
      // await agent.workflowSubtasks.updateFinishAPI(params)
      // if (autoReject?.data && rejectParams.rejectToId !== '') {
      //   toast.success('Auto reject updated sucessfully');
      // }
      // if (finish?.data) {
      //   toast.success('Finish updated sucessfully');
      // }
      // if (parallelUpdate?.data) {
      //   toast.success('Parralel subtask updated sucessfully');
      // }
      if (finish?.data || autoReject?.data) {
        toast.success('SubTask Settings updated successfully !');
      }
    } catch {
      setErrorAndLoader({
        ...errorAndLoader,
        isLoading: false,
        saveLoading: false,
      });
      toast.error('Oops! Subtask setting is failed');
    }
    setErrorAndLoader({
      ...errorAndLoader,
      isLoading: false,
      saveLoading: false,
    });
    modalCloseHandler();
  };

  return (
    <Modal onClose={modalCloseHandler} open={true}>
      <Modal.Header>Settings</Modal.Header>
      {errorAndLoader.isLoading ? (
        <div style={{ height: '297px', position: 'relative' }}>
          <LoadingComponent marginTop="0px" />
        </div>
      ) : (
        <Modal.Content>
          <Modal.Description>
            <Header as="h5" style={{ marginBottom: '1px' }}>
              Reject to
            </Header>
            <ResolveOptions
              isLoading={errorAndLoader.isLoading}
              selectedSubtask={resolveOptions.selectedSubtask}
              resolveOptions={resolveOptions.tasks || []}
              onChangeHandler={(value: { id: string; label: string }) => {
                setResolveOptions({
                  ...resolveOptions,
                  selectedSubtask: {
                    subTaskId: value.id,
                    subTaskName: value.label,
                  },
                });
              }}
              clearHandler={() => {
                setResolveOptions({
                  ...resolveOptions,
                  selectedSubtask: {
                    subTaskId: '',
                    subTaskName: '',
                  },
                });
              }}
            />
            {/* <Header as="h5" style={{ marginBottom: '1px' }}>
              Parallel Subtask
            </Header>
            <ResolveOptions
              isLoading={errorAndLoader.isLoading}
              selectedSubtask={parallelSubtask.selectedParallelSubTask}
              resolveOptions={parallelSubtask.tasks || []}
              onChangeHandler={(value: { id: string; label: string }) => {
                setParallelSubtask({
                  ...parallelSubtask,
                  selectedParallelSubTask: {
                    subTaskId: value.id,
                    subTaskName: value.label,
                  },
                });
              }}
              clearHandler={() => {
                setParallelSubtask({
                  ...parallelSubtask,
                  selectedParallelSubTask: {
                    subTaskId: '',
                    subTaskName: '',
                  },
                });
              }}
            /> */}
            <TatTimeField subtaskId={subtaskId} getchangedTat={getchangedTat} />
            <div>
              <Checkbox
                label="Finish"
                style={{ marginTop: '20px' }}
                checked={isFinish}
                onChange={(_e: SyntheticEvent, data: CheckboxProps) =>
                  setIsFinish(!!data.checked)
                }
              />
            </div>
            <div>
              <Checkbox
                label="Parallel Sub Task"
                style={{ marginTop: '20px' }}
                checked={isParallelST}
                onChange={(_e: SyntheticEvent, data: CheckboxProps) =>
                  setIsParallelST(!!data.checked)
                }
              />
            </div>
          </Modal.Description>
        </Modal.Content>
      )}
      <Modal.Actions>
        <Button color="black" onClick={modalCloseHandler}>
          Cancel
        </Button>
        <Button
          content="Save"
          loading={!!errorAndLoader.saveLoading}
          disabled={!!errorAndLoader.saveLoading}
          labelPosition="right"
          icon="checkmark"
          onClick={handleFormSubmit}
          positive
        />
      </Modal.Actions>
    </Modal>
  );
}

export default observer(AutoRejectSetting);
